<template>
  <div class="orgManage">
    <tree-box title="组织管理" other-tree>
      <template slot="tree">
        <div class="tree__title">
          <p>组织列表</p>
          <div>
<!--            <span class="add" @click="sortInfo">- 组织分类</span>-->
<!--            <span-->
<!--              class="add"-->
<!--              @click="moveInfo"-->
<!--              v-show="menusList.indexOf('DEPT_MANAGE_MOVE') != '-1'"-->
<!--              >- 移动</span-->
<!--            >-->
            <span
              class="add"
              @click="deleteInfo"
              v-show="menusList.indexOf('DEPT_MANAGE_DELETE') != '-1'"
              >- 删除</span
            >
            <span
              class="add"
              @click="addInfo"
              v-show="menusList.indexOf('DEPT_MANAGE_ADD') != '-1'"
              >+ 新建</span
            >
          </div>
        </div>
        <div class="tree__isTree">
          <div class="filterKey">
            <el-input
              placeholder="输入关键字进行过滤"
              v-model="filterText"
              slot="prepend"
              size="large"
              icon="el-icon-search"
            >
            </el-input>
          </div>
          <el-tree
            class="orgTree"
            :data="treeList"
            ref="isTree"
            node-key="deptId"
            highlight-current
            :default-checked-keys="[15]"
            default-expand-all
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
            :props="{
              children: 'children',
              label: 'deptName',
            }"
          >
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <span
                class="deptType"
                v-for="(item, index) in data.deptLabelNames"
                :key="index"
                :style="renderTreeTag(item)"
                >{{ item }}</span
              >
              <span>{{ data.deptName }}</span>
            </div>
          </el-tree>
        </div>
      </template>
      <template slot="message">
        <div class="message__tip">
          <template v-if="deptInfo.deptType == 6">
            <h3>单位信息</h3>
            <i
              @click="editInfo"
              v-show="menusList.indexOf('DEPT_MANAGE_MODIFY') != '-1'"
            >
              <img src="../img/editIcon.png" /> 编辑</i
            >
          </template>
          <template v-if="deptInfo.deptType == 1">
            <h3>自定义区域信息</h3>
            <i
              @click="editInfo"
              v-show="menusList.indexOf('DEPT_MANAGE_MODIFY') != '-1'"
            >
              <img src="../img/editIcon.png" /> 编辑</i
            >
          </template>
          <template v-if="deptInfo.deptType == 2">
            <h3>国标区域信息</h3>
          </template>
        </div>

        <div v-show="deptInfo.deptType == 6">
          <div class="message__list">
            <div class="item">
              <p>单位名称</p>
              <el-input
                style="width: 18vw"
                size="large"
                v-model="deptInfo.deptName"
                :disabled="true"
              ></el-input>
            </div>
            <div class="item">
              <p>单位标签</p>
              <el-input
                style="width: 18vw"
                size="large"
                v-model="deptInfo.deptLabelName"
                :disabled="true"
              ></el-input>
            </div>
            <div class="item">
              <p>单位负责人</p>
              <el-input
                style="width: 18vw"
                size="large"
                v-model="deptInfo.manager"
                :disabled="true"
              ></el-input>
            </div>
            <div class="item">
              <p>联系方式</p>
              <el-input
                style="width: 18vw"
                size="large"
                v-model="deptInfo.telephone"
                :disabled="true"
              ></el-input>
            </div>
            <div class="item">
              <p>所属区域</p>
              <el-input
                style="width: 18vw"
                size="large"
                v-model="deptInfo.parentDeptName"
                :disabled="true"
              ></el-input>
            </div>
            <div class="item">
              <p>经纬度</p>
              <el-input
                style="width: 18vw"
                size="large"
                :value="
                  deptInfo.lat && deptInfo.lng && deptInfo.lng!='null'
                    ? deptInfo.lng + ',' + deptInfo.lat
                    : ''
                "
                :disabled="true"
              ></el-input>
            </div>
          </div>
          <div id="map2"></div>
          <div class="message__tip">
            <h3>单位下级</h3>
            <i @click="editSuTree"> <img src="../img/editIcon.png" /> 编辑</i>
          </div>
          <div class="tableList">
            <el-table
              :data="(subTree[0] || {}).children"
              class="tableList_table"
              row-key="deptId"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column align="center" prop="deptName" label="层级名称">
              </el-table-column>
              <el-table-column prop="name" align="deptType" label="层级等级">
                <template slot-scope="scope">
                  {{ getDeptType(scope.row.deptType) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <template v-if="deptInfo.deptType == 1 || deptInfo.deptType == 2">
          <div class="message__list">
            <div class="item">
              <p>区域名称</p>
              <el-input
                style="width: 18vw"
                size="large"
                v-model="deptInfo.deptName"
                :disabled="true"
              ></el-input>
            </div>
            <div class="item">
              <p>所属区域</p>
              <el-input
                style="width: 18vw"
                size="large"
                v-model="parentDeptName"
                :disabled="true"
              ></el-input>
            </div>
            <div class="item" style="width: 18vw"></div>
          </div>
        </template>
      </template>
    </tree-box>
    <org-edit-dialog
      ref="orgDialog"
      @update="queryTreeList"
      v-if="editDialog"
      :deptInfo="deptInfo"
      :editDialog.sync="editDialog"
      :action="action"
      :parentNode="parentNode"
    ></org-edit-dialog>
    <org-user-defined-dialog
      ref="userDefined"
      @update="queryTreeList"
      :deptInfo="deptInfo"
      v-if="userDefined"
      :userDefined.sync="userDefined"
    ></org-user-defined-dialog>
    <el-dialog
      :visible.sync="checkDialog"
      width="25%"
      :top="'25vh'"
      class="addCheckDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="180px"
        :model="form"
        ref="checkForm"
        :rules="rules"
        class="addCheck"
      >
        <el-form-item label="请选择移动到组织节点" prop="addStatus">
          <el-cascader
            v-model="form.moveNode"
            :show-all-levels="false"
            :options="treeList"
            :props="{
              value: 'deptId',
              label: 'deptName',
              checkStrictly: true,
            }"
            size="large"
          ></el-cascader>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmType">确 定</el-button>
        <el-button @click="checkDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="orgDialog"
      width="25%"
      :top="'25vh'"
      class="addCheckDialog"
      :close-on-click-modal="false"
    >
      <el-form
        label-width="120px"
        :model="orgForm"
        ref="orgForm"
        class="addCheck"
        :rules="typeRules"
      >
        <el-form-item label="组织类型" prop="deptType">
          <el-select
            size="large"
            v-model="orgForm.deptType"
            placeholder="请选择"
            style="width: 240px"
          >
            <el-option
              v-for="item in deptType"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmOrg">确 定</el-button>
        <el-button @click="orgDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="orgSubDialog"
      width="25%"
      :top="'15vh'"
      class="addCheckDialog"
      :close-on-click-modal="false"
      title="编辑单位下级"
    >
      <div class="supTree">
        <div
          v-if="((subTree[0] || {}).children || []).length == 0"
          @click="addSupInfo(deptInfo.deptId)"
          style="
            width: 100%;
            text-align: center;
            color: #2a62ff;
            cursor: pointer;
          "
        >
          + 新增子节点
        </div>
        <div v-if="((subTree[0] || {}).children || []).length != 0">
          <el-tree
            style="width: 400px"
            :data="(subTree[0] || {}).children"
            ref="tree"
            node-key="deptId"
            highlight-current
            :default-checked-keys="[15]"
            :props="{
              children: 'children',
              label: 'deptName',
            }"
          >
            <span class="custom-tree-node supNode" slot-scope="{ node, data }">
              <span v-if="!data.editStatus">{{ data.deptName }}</span>
              <el-input
                class="editSup"
                v-if="data.editStatus"
                v-model="data.deptName"
                size="small"
                @blur="editSupInfo(data)"
              ></el-input>
              <span class="groupIcon">
                <img
                  src="../img/sameIcon.png"
                  alt="新增同级单位"
                  title="新增同级单位"
                  @click="addSupInfo(data.parentId)"
                />
                <img
                  src="../img/addIcon.png"
                  alt="新增下级单位"
                  title="新增下级单位"
                  @click="addSupInfo(data.deptId, data)"
                />
                <img
                  src="../img/editIcon.png"
                  alt="编辑下级单位"
                  title="编辑下级单位"
                  @click="data.editStatus = true"
                />
                <img
                  src="../img/delIcon.png"
                  alt="删除下级单位"
                  title="删除下级单位"
                  @click="deleteSupInfo(data.deptId)"
                />
              </span>
            </span>
          </el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmOrgSup">确 定</el-button>
        <el-button @click="orgSubDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "../../../utils/Axios";
import treeBox from "./components/treeBox";
import orgEditDialog from "./components/orgEditDialog";
import orgUserDefinedDialog from "./components/orgUserDefinedDialog";
import Vue from "vue";
export default {
  name: "orgManger",
  components: { treeBox, orgEditDialog, orgUserDefinedDialog },
  data() {
    return {
      map: null,
      pageNum: 1,
      showNum: 10,
      treeList: [],
      menusList: [],

      filterText: "",
      deptInfo: {}, //当前选中节点
      orgForm: {
        deptType: "",
      },
      typeRules: {
        deptType: [
          {
            required: true,
            message: "请选择组织类型",
            trigger: "blur",
          },
        ],
      },
      form: {},
      props: { multiple: true, value: "id", label: "name" },
      deptType: [
        {
          name: "自定义区域",
          value: 1,
        },
        {
          name: "国标区域",
          value: 2,
        },
        {
          name: "单位",
          value: 6,
        },
        {
          name: "单位子组织",
          value: 7,
        },
      ],
      labelTree: [],
      subTree: [],
      rules: {
        moveNode: [
          {
            required: true,
            message: "请选择移动到的组织节点",
            trigger: "blur",
          },
        ],
      },
      parentDeptName: "",
      supStatus: false, //子节点的
      orgDialog: false, //标签类型弹框
      checkDialog: false, //选择移动组织弹框
      editDialog: false, //新增编辑单位状态
      clickStatus: false, //用于记录是否为单位点击
      userDefined: false, //新增编辑自定义组织状态
      orgSubDialog: false, //编辑单位下级
      action: "",
      parentNode: {
        deptName: "全国",
      }, //父节点 用于获取国标组织列表
      level: 0, //用于记录树节点的点击 利于控制是否出现新增选择弹框 但树节点为顶级或者未选择树节点的时候出现弹框，选择任何子节点都出现新增单位弹框
    };
  },
  watch: {
    filterText(val) {
      this.$refs.isTree.filter(val);
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    editSuTree() {
      if (this.clickStatus) {
        this.action = "edit";
        this.orgSubDialog = true;
      } else {
        this.$message.warning("请选择单位组织！");
      }
    },
    editSupInfo(row) {

      this.$nextTick(() => {

        Axios.ajax({
          url: "/dept/update",
          method: "post",
          data: row,
        }).then((res) => {
          if (res.resultCode == 0) {
            this.queryUserList();
            this.$message.success("修改成功！");
          } else {
            this.$message.warning(res.resultMessage);
          }
        });
      });
    },
    confirmOrgSup() {
      this.queryTreeList();
      this.orgSubDialog = false;
      this.subTree = [];
    },
    confirmType() {
      this.$refs.checkForm.validate((va) => {
        if (va) {
          const data = {
            deptId: this.deptInfo.deptId,
            parentId: Array.isArray(this.form.moveNode)
              ? this.form.moveNode[this.form.moveNode.length - 1]
              : this.form.moveNode,
          };
          if (data.deptId != data.parentId) {
            Axios.ajax({
              url: "/dept/move",
              method: "post",
              data: data,
            }).then((res) => {
              if (res.resultCode == 0) {
                this.$message.success("移动成功！");
                this.checkDialog = false;
                this.queryTreeList();
              } else {
                this.$message.warning(res.resultMessage);
              }
            });
          } else {
            this.$message.warning("不能移动到该节点！");
          }
        }
      });
    },
    confirmOrg() {
      this.$refs.orgForm.validate((va) => {
        if (va) {
          Axios.ajax({
            method: "post",
            url: "/dept/editType",
            data: {
              deptId: this.deptInfo.deptId,
              deptType: this.orgForm.deptType,
            },
          }).then((res) => {
            if (res.resultCode == 0) {
              this.$message.success("分类成功！");
              this.orgDialog = false;
              this.queryTreeList();
            } else {
              this.$message.warning(res.resultMessage);
            }
          });
        }
      });
    },
    moveInfo() {
      this.checkDialog = true;
    },
    sortInfo() {
      this.orgForm.deptType = this.deptInfo.deptType;
      this.orgDialog = true;
    },
    deleteSupInfo(id) {
      this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Axios.ajax({
          url: "/dept/delete",
          method: "post",
          data: {
            deptId: id,
          },
        }).then((res) => {
          if (res.resultCode == 0) {
            this.queryUserList();
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.resultMessage);
          }
        });
      });
    },
    deleteInfo() {

      if (this.deptInfo.deptId) {
        this.$confirm("确认删除？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          Axios.ajax({
            url: "/dept/delete",
            method: "post",
            data: {
              deptId: this.deptInfo.deptId,
            },
          }).then((res) => {
            if (res.resultCode == 0) {
              this.$message.success("删除成功！");
              this.queryTreeList();
            } else {
              this.$message.warning(res.resultMessage);
            }
          });
        });
      } else {
        this.$message.warning("请选择单位节点！");
      }
    },
    addInfo() {

      if (this.deptInfo.deptType == 1) {
        this.action = "add";
        this.userDefined = true;
      } else if (this.deptInfo.deptType == 2) {
        this.action = "add";
        this.editDialog = true;
      } else {
        this.$message.warning("请选择非单位节点！");
      }
    },
    addSupInfo(id = null, data = {}) {
      if (data.subLevel > 5) {
        this.$message.warning("单位下级限制最多创建5级");
      } else {
        this.$nextTick(() => {
          const data = {
            deptName: "单位下级",
            deptType: 7,
            parentId: id,
          };
          Axios.ajax({
            url: "/dept/add",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.resultCode == 0) {
              this.queryUserList();
              this.$message.success("添加成功！");
            } else {
              this.$message.warning(res.resultMessage);
            }
          });
        });
      }
    },

    initMap(station = {}) {
      let that = this;
      
      // 天地图初始化
      const map = (this.map = new T.Map("map2", {
        projection: "EPSG:4326"
      }));
      
      // 设置中心点和缩放级别
      const center = station && station.lng && station.lat
        ? new T.LngLat(station.lng, station.lat)
        : new T.LngLat(120.21937542, 30.25924446);
      
      map.centerAndZoom(center, 14);
      
      // 添加控件
      //map.addControl(new T.Control.Scale());
      map.addControl(new T.Control.Zoom());
      
      // 添加标记点
      if (station && station.lng && station.lat) {
        const marker = new T.Marker(
          new T.LngLat(station.lng, station.lat),
          {
            icon: new T.Icon({
              iconUrl: require("../img/img.png"),
              iconSize: new T.Point(25, 34),
              iconAnchor: new T.Point(12, 34)
            }),
            draggable: false
          }
        );
        
        // 添加标签
        const label = new T.Label({
          text: station.deptName,
          position: new T.LngLat(station.lng, station.lat),
          offset: new T.Point(0, -40) // 调整标签位置
        });
        
        map.addOverLay(marker);
        map.addOverLay(label);
      }
    },

    initMap_baidu(station = {}) {
      let that = this;
      const map = (this.map = new AMap.Map("map2", {
        center:
          station && station.lng && station.lat
            ? new AMap.LngLat(station.lng, station.lat)
            : [120.21937542, 30.25924446],
        zoom: 14,
        pitch: 30, // 地图俯仰角度，有效范围 0 度- 83 度
        resizeEnable: true,
        expandZoomRange: true,
        zooms: [3, 20],
        showBuildingBlock: true,
      }));
      that.stationLayer = new AMap.OverlayGroup();

      if (station) {
        const marker = new AMap.Marker({
          label: {
            content: station.deptName,
            direction: "top", //决定提示内容在icon的方位
          },
          icon: require("../img/img.png"),
          position:
            station.lng && station.lat
              ? new AMap.LngLat(station.lng, station.lat)
              : [120.21937542, 30.25924446],
          zIndex: 1000,
          extData: station,
        });
        map.add(marker);
      }
    },


    queryTreeList() {
      Axios.ajax({
        url: "/dept/getDeptTree",
        method: "get",
      }).then(({ data }) => {
        this.deptInfo = {};
        this.treeList = data;
      });
    },
    handleNodeClick(row, node) {
      console.log(row,node)
      if (row.deptType !== 7)
      {
        if (
          node.parent.data.districtLevel == "city" &&
          (row.districtLevel == "district" || row.districtLevel == "street")
        )
        {
          //单选区级行政区的时候，需要拿上级的deptId

          row.issolo =true;
        }
        this.deptInfo = row;
        this.parentDeptName = row.parentName;
        if (Array.isArray(this.deptInfo.deptLabelNames)) {
          const str = this.deptInfo.deptLabelNames.join();
          this.deptInfo.deptLabelName = str;
        }
        //点击根节点时可能返回数组
        this.parentNode = node.parent.data;
        this.parentNode.childrenName = this.deptInfo.deptName;
        if (row.deptType == 6 || row.deptType == 1) {
          this.queryUserList();
          this.clickStatus = true;
          this.deptInfo.lngLat = this.deptInfo.lng + "," + this.deptInfo.lat;
          this.deptInfo.parentDeptName = node.parent.data.deptName;
          this.initMap(this.deptInfo);

        } else {
          this.subTree = [];
          this.clickStatus = false;
        }
      } else {
        // this.deptInfo.deptId = row.deptId;
        this.$message.warning("请选择非单位子节点！");
      }
    },
    editInfo() {
      if (this.clickStatus) {
        this.action = "edit";
        this.editDialog = true;
      } else {
        this.$message.warning("请选择单位组织！");
      }
    },
    queryUserList() {
      Axios.ajax({
        method: "post",
        url: "/dept/getDeptSubTree",
        data: {
          deptId: this.deptInfo.deptId,
        },
      }).then((res) => {
        this.subTree = this.handleSupData(res.data);
        console.log(this.subTree)
      });
    },
    handleSupData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].children == null || data[i].children.length < 1) {
          data[i].editStatus = false;
        } else {
          data[i].editStatus = false;
          this.handleSupData(data[i].children);
        }
      }
      return data;
    },
    renderTreeTag(item) {
      const tagColor = [
        {
          bgColor: "#E8EEFE",
          fontColor: "#5482FC",
        },
        {
          bgColor: "#FFF6EB",
          fontColor: "#FFAB46",
        },
        {
          bgColor: "#E9F9E5",
          fontColor: "#36CD28",
        },
        {
          bgColor: "#FFD8E4",
          fontColor: "#FF3671",
        },
        {
          bgColor: "#FFE6D8",
          fontColor: "#FF7528",
        },
        {
          bgColor: "#F5E8FE",
          fontColor: "#B756FC",
        },
        {
          bgColor: "#EBFDFF",
          fontColor: "#49B4FF",
        },
        {
          bgColor: "#FFD5D5",
          fontColor: "#FF5151",
        },
        {
          bgColor: "#FFFFE2",
          fontColor: "#FCD654",
        },
        {
          bgColor: "#CBFCED",
          fontColor: "#008B61",
        },
      ];
      switch (item) {
        case "学校":
          return {
            color: tagColor[0].fontColor,
            background: tagColor[0].bgColor,
          };
        case "工厂":
          return {
            color: tagColor[1].fontColor,
            background: tagColor[1].bgColor,
          };
        case "养老":
          return {
            color: tagColor[2].fontColor,
            background: tagColor[2].bgColor,
          };
        case "商户":
          return {
            color: tagColor[3].fontColor,
            background: tagColor[3].bgColor,
          };
        case "测试":
          return {
            color: tagColor[4].fontColor,
            background: tagColor[4].bgColor,
          };
        case "老乡鸡":
          return {
            color: tagColor[5].fontColor,
            background: tagColor[5].bgColor,
          };
        default:
          return {
            color: tagColor[6].fontColor,
            background: tagColor[6].bgColor,
          };
      }
    },
    getDeptType(row) {
      switch (row) {
        case 1: {
          return "自定义区域";
        }
        case 2: {
          return "国标区域";
        }
        case 6: {
          return "单位";
        }
        case 7: {
          return "单位子区域";
        }
        default: {
          return "自定义区域";
        }
      }
    },
  },
  created() {},
  mounted() {
    this.menusList = Vue.prototype.menusList;
    this.initMap();
    this.queryTreeList();
  },
};
</script>

<style lang="less" scoped>
.orgManage {
  .tree {
    width: 340px;
    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      .add {
        margin-right: 12px;
        color: #2a62ff;
        cursor: pointer;
      }
    }
    &__isTree {
      overflow: auto;
      height: 95%;
      width: 100%;
      .orgTree {
        width: 400px;
      }
    }
  }
  .message {
    &__tip {
      display: flex;
      justify-content: space-between;
      h3 {
        padding: 0 10px;
        border-left: 2px solid #2a62ff;
        margin-bottom: 16px;
      }
      i {
        color: #2a62ff;
      }
    }
    &__list {
      justify-content: space-between;
      display: flex;
      flex-wrap: wrap;
      .item {
        margin-bottom: 24px;
        p {
          margin-bottom: 12px;
        }
      }
    }
    #map2 {
      width: 100%;
      height: 290px;
      margin-bottom: 42px;
    }
    .tableList {
      width: 99%;
      max-height: 220px;
      overflow: auto;
      &__table {
        width: 95%;
        margin-bottom: 20px;
      }
    }
  }
}
i {
  cursor: pointer;
}
.editSup {
}
.addCheck {
  margin: 0 24px;
}
.custom-tree-node {
  .deptType {
    margin-right: 8px;
    border-radius: 4px;
    padding: 2px 5px;
  }
}
.filterKey {
  width: 100%;
  padding: 0 10px 10px;
}
.supNode {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .groupIcon {
    i {
      margin-left: 12px;
    }
  }
}
.supTree {
  overflow: auto;
  max-height: 60vh;
  margin-left: 24px;
  img {
    margin-left: 12px;
  }
}
</style>
<style lang="less">
//高德地图样式修改
//.amap-logo {
 // display: none !important; //去掉高德地图logo
//}
//.amap-copyright {
 // opacity: 0 !important; //去掉高德的版本号
//}
.tdt-control-copyright {
  display: none !important;
}
.tdt-control-scale {
  display: none !important;
}
.addCheckDialog {
  .el-dialog {
    .el-dialog__body {
      padding: 30px 0 0 0 !important;
    }
  }
}
</style>
